import React from 'react';
import Home from './pages/Home';
import Idroflog from './pages/Idroflog';
import Laluvit from './pages/laluvit';
import Oftaial from './pages/Oftaial';
import Vesti from './pages/Vesti';
import VestDetail from './pages/VestDetail';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import './i18n';


function App() {
  return (

    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/idroflog" element={<Idroflog />} />
          <Route path="/laluvit" element={<Laluvit />} />
          <Route path="/oftaial-plus" element={<Oftaial />} />
          <Route path="/vesti" element={<Vesti />} />
          <Route path="/vesti/:slug" element={<VestDetail />} />
        </Route>
      </Routes>



    </BrowserRouter>

  );
}

export default App
